import { useEffect, useState } from "react";
import AsideV2 from "../../../components/asidev2/AsideV2";
import "../home/Styles.css";
import { getMiscDataByType, saveMiscById } from "../../../hooks/firebase";
import { FaCheck } from "react-icons/fa6";
import HeaderV2 from "../../../components/adminV2/header/Header";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function ConfigsV2() {
  const [configs, setConfigs] = useState({});
  const [banners, setBanners] = useState({
    main: null,
    firstSession2: null,
    secondSession2: null,
  });

  useEffect(() => {
    async function load() {
      const result = await getMiscDataByType();
      setConfigs(result);
    }
    load();
  }, []);

  const handleChange = (id, field, value) => {
    setConfigs((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleAddressChange = (id, value) => {
    const slug = generateSlug(value);
    setConfigs((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        address: value,
        slug,
      },
    }));
  };

  const handleSave = async (id) => {
    try {
      const updated = configs[id];
      await saveMiscById(id, updated);
      alert("Configurações salvas!");
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar configurações.");
    }
  };

  const handleSaveBanners = async () => {
    const storage = getStorage();

    try {
      if (banners.main) {
        const storageRef = ref(storage, "banners/main-banner.png");
        await uploadBytes(storageRef, banners.main);
        const url = await getDownloadURL(storageRef);
        console.log("Banner Principal salvo:", url);
        // Se quiser salvar no Firestore:
        await saveMiscById("banners", { mainBanner: url }, true);
      }

      if (banners.firstSession2) {
        const storageRef = ref(storage, "banners/first-banner-session-2.png");
        await uploadBytes(storageRef, banners.firstSession2);
        const url = await getDownloadURL(storageRef);
        console.log("Banner Sessão 2 (Principal) salvo:", url);
        await saveMiscById("banners", { firstSession2: url }, true);
      }

      if (banners.secondSession2) {
        const storageRef = ref(storage, "banners/second-banner-session-2.png");
        await uploadBytes(storageRef, banners.secondSession2);
        const url = await getDownloadURL(storageRef);
        console.log("Banner Sessão 2 (Secundário) salvo:", url);
        await saveMiscById("banners", { secondSession2: url }, true);
      }

      alert("Banners atualizados com sucesso!");
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar banners.");
    }
  };

  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  return (
    <div>
      <AsideV2 />
      <main className="main-wrapper p-4">
        <HeaderV2 />
        <div className="container-fluid">
          <h2 className="mb-4">Configurações gerais</h2>
          <div className="row">
            {Object.entries(configs).map(([id, data]) => (
              <div className="col-md-10 col-lg-8 mb-4" key={id}>
                <div className="card shadow">
                  <div className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Endereço</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data.address}
                        onChange={(e) =>
                          handleAddressChange(id, e.target.value)
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">CNPJ</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data.cnpj}
                        onChange={(e) =>
                          handleChange(id, "cnpj", e.target.value)
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">E-mail</label>
                      <input
                        type="email"
                        className="form-control"
                        value={data.email}
                        onChange={(e) =>
                          handleChange(id, "email", e.target.value)
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">WhatsApp</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data.whatsapp}
                        onChange={(e) =>
                          handleChange(id, "whatsapp", e.target.value)
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Copy (Rodapé)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data.copy}
                        onChange={(e) =>
                          handleChange(id, "copy", e.target.value)
                        }
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-success"
                        onClick={() => handleSave(id)}
                      >
                        <FaCheck /> Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Sessão de Banners */}
          <div className="row">
            <div className="col-md-10 col-lg-8 mb-4">
              <div className="card shadow">
                <div className="card-body">
                  <h5 className="mb-3">Banners</h5>

                  <div className="mb-3">
                    <label className="form-label">Banner Principal</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={(e) =>
                        setBanners((prev) => ({
                          ...prev,
                          main: e.target.files[0],
                        }))
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Banner Sessão 2 (Principal)</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={(e) =>
                        setBanners((prev) => ({
                          ...prev,
                          firstSession2: e.target.files[0],
                        }))
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Banner Sessão 2 (Secundário)</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={(e) =>
                        setBanners((prev) => ({
                          ...prev,
                          secondSession2: e.target.files[0],
                        }))
                      }
                    />
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-success"
                      onClick={handleSaveBanners}
                    >
                      <FaCheck /> Salvar Banners
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Fim Sessão de Banners */}
        </div>
      </main>
    </div>
  );
}
